import {SchoolModelV5} from 'resources/GeneratedModels/School/SchoolModel.v5';
import {schoolModelValidators} from './SchoolModel.v5.validators';
import {schoolExtensions} from 'resources/augmented/School/school.extensions';

SchoolModelV5.addValidators(schoolModelValidators);
SchoolModelV5.extend(schoolExtensions);

export {SchoolModelV5};
